// extracted by mini-css-extract-plugin
module.exports = {"bgGradLightBlue":"HTuSp"};